module.exports = __webpack_public_path__ + "assets/Hotspot.3fdd370e.svg";